import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 76350FC3-7629-4247-9D09-8AB9AF9BC6CF
 * name chevron-double-left
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-double-left.svg
 * tags
 * - Arrow 
 */
export const ChevronDoubleLeftIcon = createSvgIcon(<><path d="M18.41,7.41L17,6L11,12L17,18L18.41,16.59L13.83,12L18.41,7.41M12.41,7.41L11,6L5,12L11,18L12.41,16.59L7.83,12L12.41,7.41Z" /></>, 'ChevronDoubleLeftIcon');
export default ChevronDoubleLeftIcon